import { defineStore } from 'pinia';
import api from '@/services/api';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        // Leemos directamente del caché al iniciar
        token: localStorage.getItem('v_token') || '',
        refreshTokenStr: localStorage.getItem('v_refresh') || '',
        username: localStorage.getItem('v_username') || '',
        avatarURL: localStorage.getItem('v_avatar') || '',
        isLoggedIn: localStorage.getItem('v_isLoggedIn') === 'true', // Convertimos el string a booleano
    }),
    actions: {
        loginSuccess(response) {
            this.token = response.access_token;
            this.refreshTokenStr = response.refresh_token;

            const user = response.user;
            this.username = user.display_name || user.username || user.Username;
            this.avatarURL = user.avatar_url || `https://ui-avatars.com/api/?name=${this.username}&background=random`;
            this.isLoggedIn = true;

            // GUARDADO MANUAL (¡Esto nunca falla!)
            localStorage.setItem('v_token', this.token);
            localStorage.setItem('v_refresh', this.refreshTokenStr);
            localStorage.setItem('v_username', this.username);
            localStorage.setItem('v_avatar', this.avatarURL);
            localStorage.setItem('v_isLoggedIn', 'true');
        },
        logout() {
            this.token = '';
            this.refreshTokenStr = '';
            this.username = '';
            this.avatarURL = '';
            this.isLoggedIn = false;

            // LIMPIEZA MANUAL
            localStorage.removeItem('v_token');
            localStorage.removeItem('v_refresh');
            localStorage.removeItem('v_username');
            localStorage.removeItem('v_avatar');
            localStorage.setItem('v_isLoggedIn', 'false');
        },
        async refreshToken() {
            try {
                const response = await api.post('/auth/refresh', {
                    refresh_token: this.refreshTokenStr
                });

                if (response.data.access_token) {
                    this.token = response.data.access_token;
                    this.refreshTokenStr = response.data.refresh_token;

                    // Actualizamos el caché también
                    localStorage.setItem('v_token', this.token);
                    localStorage.setItem('v_refresh', this.refreshTokenStr);

                    return this.token;
                } else {
                    throw new Error("No se recibió token nuevo");
                }
            } catch (error) {
                this.logout();
                throw error;
            }
        }
    }
});